import { ADD_CHAT_ROOM_USERS, CREATE_CHAT_GROUP, DELETE_CHAT_GROUP, FORWARD_MESASGE, GET_USER_CHATROOMS, REMOVE_CHAT_GROUP_USER, UPDATE_CHAT_ROOM_NAME, USER_DATA } from '../api-routes';

import { API_BASE_URL } from '../../pages/Products/api';
import { ApiError } from '../../common/ApiError';
import axios from 'axios';

export const getChatRoomData = async (chatRoomID) => {
  return await axios
    .get(`${API_BASE_URL}/ChatRoom/${chatRoomID}/Users`)
    .then((x) => x.data.Result)
    .catch((x) => console.log(x));
};

export async function getChatRoomMediaMessages(chatRoomId) {
  return await axios
    .get(`${API_BASE_URL}/ChatRoom/${chatRoomId}/MediaMessages`)
    .then((response) => {
      if (response.status !== 200 || response.data?.Success === false) {
        return Promise.reject(new ApiError(response.data));
      }
      return Array.isArray(response.data?.Result) ? response.data.Result : [];
    })
    .catch((err) => Promise.reject(new ApiError(err)));
}

export async function getUserData(id) {
  return await axios
    .get(USER_DATA(id))
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new ApiError(response.data));
      }
      return response.data.Result;
    })
    .catch((err) => Promise.reject(new ApiError(err)));
}

export async function getUserChatRooms(id) {
  return await axios
    .get(GET_USER_CHATROOMS(id))
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new ApiError(response.data));
      }
      return response.data.Result;
    })
    .catch((err) => Promise.reject(new ApiError(err)));
}

// Forwards one message to one or more rooms in a SINGLE request. Returns
// { ForwardedRoomIDs, FailedRoomIDs } so the caller can report partial success.
export async function shareMessage(messageId, roomIds) {
  return await axios
    .post(FORWARD_MESASGE, {
      ChatMessageID: messageId,
      RoomIDs: roomIds,
    })
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new ApiError(response.data));
      }
      return response.data.Result;
    })
    .catch((err) => Promise.reject(new ApiError(err)));
}

export async function createChatGroup(name, userIds) {
  return await axios
    .post(CREATE_CHAT_GROUP, {
      ChatRoomName: name,
      UserIds: userIds,
    })
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new ApiError(response.data));
      }
      if (!response.data.Success) {
        return Promise.reject(new Error(response.data.Message || 'Failed to create group chat'));
      }
      return response.data.Result;
    })
    .catch((err) => {
      if (err instanceof Error) throw err;
      throw new ApiError(err);
    });
}

export async function deleteChatGroup(groupId) {
  return await axios
    .delete(DELETE_CHAT_GROUP(groupId))
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new ApiError(response.data));
      }
      return response.data.Result;
    })
    .catch((err) => Promise.reject(new ApiError(err)));
}
export async function removeChatGroupUser(groupId, userIds) {
  return await axios
    .post(REMOVE_CHAT_GROUP_USER, {
      ChatRoomId: groupId,
      UserIds: userIds
    })
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new ApiError(response.data));
      }
      return response.data.Result;
    })
    .catch((err) => Promise.reject(new ApiError(err)));
}
export async function updateChatRoomName(groupId, chatRoomName) {
  return await axios
    .post(UPDATE_CHAT_ROOM_NAME, {
      ChatRoomId: groupId,
      ChatRoomName: chatRoomName
    })
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new ApiError(response.data.Message));
      }
      return response.data;
    })
    .catch((err) => Promise.reject(new ApiError(err)));
}
export async function addChatRoomUser(groupId, userIds) {
  return await axios
    .post(ADD_CHAT_ROOM_USERS, {
      ChatRoomId: groupId,
      UserIds: userIds
    })
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new ApiError(response.data));
      }
      return response.data.Result;
    })
    .catch((err) => Promise.reject(new ApiError(err)));
}